import React, { useState, useEffect } from 'react';
import { useProducts } from '../context/ProductsContext';
import { useAuth } from '../context/AuthContext';
import ProductManagementInterface from './ProductManagementInterface';

const ProductSyncTest = () => {
  const { products, getCategories } = useProducts();
  const { isAuthenticated, isAdmin } = useAuth();
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [storageCount, setStorageCount] = useState(0);
  const [showProductInterface, setShowProductInterface] = useState(false);
  const [categoriesCount, setCategoriesCount] = useState(0);

  useEffect(() => {
    const saved = localStorage.getItem('farmProducts');
    setStorageCount(saved ? JSON.parse(saved).length : 0);
    
    // Mettre à jour le nombre de catégories
    const categories = getCategories();
    setCategoriesCount(categories.length);
  }, [products, getCategories]);

  useEffect(() => {
    const handleUpdate = () => {
      setLastUpdate(new Date());
    };

    const handleCategoriesUpdate = () => {
      console.log('📂 Mise à jour des catégories détectée');
      setLastUpdate(new Date());
      // Mettre à jour le nombre de catégories
      const categories = getCategories();
      setCategoriesCount(categories.length);
    };

    window.addEventListener('productsUpdated', handleUpdate);
    window.addEventListener('categoriesUpdated', handleCategoriesUpdate);
    window.addEventListener('forceUpdateCategories', handleCategoriesUpdate);
    
    return () => {
      window.removeEventListener('productsUpdated', handleUpdate);
      window.removeEventListener('categoriesUpdated', handleCategoriesUpdate);
      window.removeEventListener('forceUpdateCategories', handleCategoriesUpdate);
    };
  }, [getCategories]);

  // Ne pas afficher le panneau si l'utilisateur n'est pas admin connecté
  if (!isAuthenticated || !isAdmin) {
    return null;
  }

  const testSync = () => {
    console.log('🧪 Test de synchronisation manuel');
    const saved = localStorage.getItem('farmProducts');
    if (saved) {
      const parsedProducts = JSON.parse(saved);
      console.log('💾 Produits dans localStorage:', parsedProducts);
      setStorageCount(parsedProducts.length);
    }
  };

  const checkLocalStorage = () => {
    const saved = localStorage.getItem('farmProducts');
    const count = saved ? JSON.parse(saved).length : 0;
    console.log('💾 Données dans localStorage:', count, 'produits');
    setStorageCount(count);
    
    // Vérifier aussi les catégories
    const categories = getCategories();
    console.log('📂 Catégories disponibles:', categories);
    setCategoriesCount(categories.length);
  };

  const addTestProduct = () => {
    const saved = localStorage.getItem('farmProducts');
    const products = saved ? JSON.parse(saved) : [];
    const nextId = Math.max(...products.map(p => p.id), 0) + 1;
    
    const newProduct = {
      id: nextId,
      name: `Produit Test ${nextId}`,
      category: 'Test',
      price: 15.99,
      unit: 'kg',
      stock: 10,
      image: '/images/beef-steak.svg',
      description: 'Produit de test créé manuellement',
      featured: false,
      createdAt: new Date().toISOString()
    };
    
    products.push(newProduct);
    localStorage.setItem('farmProducts', JSON.stringify(products));
    
    // Déclencher l'événement de synchronisation
    window.dispatchEvent(new CustomEvent('productsUpdated', {
      detail: { products, count: products.length }
    }));
    
    console.log('✅ Produit de test ajouté:', newProduct.name);
  };

  const testCategories = () => {
    const categories = getCategories();
    console.log('📂 Test des catégories:', categories);
    setCategoriesCount(categories.length);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '20px',
      background: 'rgba(0, 0, 0, 0.9)',
      color: 'white',
      padding: '15px',
      borderRadius: '8px',
      fontSize: '12px',
      zIndex: 9999,
      minWidth: '200px'
    }}>
      <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
        🔄 Test Synchronisation
      </div>
      <div>Context: {products.length} produits</div>
      <div>Storage: {storageCount} produits</div>
      <div>Catégories: {categoriesCount}</div>
      <div style={{ fontSize: '10px', opacity: 0.7 }}>
        Dernière MAJ: {lastUpdate.toLocaleTimeString()}
      </div>
      <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <button onClick={testSync} style={{ padding: '5px', fontSize: '11px' }}>
          🔍 Vérifier
        </button>
        <button onClick={checkLocalStorage} style={{ padding: '5px', fontSize: '11px' }}>
          💾 Check Storage
        </button>
        <button onClick={addTestProduct} style={{ padding: '5px', fontSize: '11px', background: '#28a745' }}>
          ➕ Test Produit
        </button>
        <button onClick={() => setShowProductInterface(true)} style={{ padding: '5px', fontSize: '11px', background: '#007bff' }}>
          🛠️ Interface Produits
        </button>
        <button onClick={testCategories} style={{ padding: '5px', fontSize: '11px', background: '#17a2b8' }}>
          📂 Test Catégories
        </button>
      </div>
      
      {/* Interface de gestion des produits */}
      <ProductManagementInterface 
        isOpen={showProductInterface}
        onClose={() => setShowProductInterface(false)}
      />
    </div>
  );
};

export default ProductSyncTest;
